import EdocatButton from './Button';
export default EdocatButton;
